// When the booking UI stops offering an event. Client-side only: every
// picker, selector and bookable-events filter hides an event once it is
// inside this many hours of its local sitting.
export const BOOKING_CUTOFF_HOURS = 12;

// The server's hard cutoff, deliberately ONE HOUR LATER than the client's.
// The gap is a grace period: someone who loaded the picker just before the
// client cutoff, or who is midway through checkout when it passes, still gets
// to finish rather than being rejected after paying. Past this, the booking
// API refuses regardless of what the client offered.
//
// It also bounds the auto-refund pipeline. The final refund pass opens at
// T-6h (services/eventOps/refundReconciler.ts) on the assumption that the
// guest list is settled by then; without a server-side cutoff, bookings kept
// arriving at T-7h and T-6h and landed after their city's refund pass had
// already run.
export const SERVER_BOOKING_CUTOFF_HOURS = 11;

export const CANCELLATION_REFUND_WINDOW_HOURS = 48;

// No-show fee per currency, in minor units (cents, pence; yen has none).
// Shown in the booking disclaimer and charged by server/src/services/noShow,
// one table so the two never disagree. Roughly half a one-time seat, rounded
// to a clean local number. A currency missing here falls back to USD.
export const NO_SHOW_FEE_BY_CURRENCY: Record<string, number> = {
  usd: 800,
  eur: 700,
  gbp: 600,
  cad: 1100,
  mxn: 14000,
  aud: 1200,
  jpy: 1200,
  thb: 28000,
  zar: 15000,
  brl: 4000,
};
export const NO_SHOW_DEFAULT_CURRENCY = "usd";

/** The fee for a currency, falling back to USD for one we don't price. */
export function noShowFeeFor(currency: string | null | undefined): { amount: number; currency: string } {
  const key = (currency ?? "").toLowerCase();
  return key in NO_SHOW_FEE_BY_CURRENCY
    ? { amount: NO_SHOW_FEE_BY_CURRENCY[key], currency: key }
    : { amount: NO_SHOW_FEE_BY_CURRENCY[NO_SHOW_DEFAULT_CURRENCY], currency: NO_SHOW_DEFAULT_CURRENCY };
}
// Hours between the no-show notice email and the charge; the guest's window to
// reply and be excused.
export const NO_SHOW_GRACE_HOURS = 72;
